import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class AhsSplashService {
	public isShown: boolean = false;
	private hasRun: boolean = false;
	private time: number = 0;
	private timer;

	constructor() {}

	public setLoad: () => Promise<any>;

	// the splash shows on startup, and defaults to turn off in after 4 seconds if the hide method is not called
	// to show the splash again at a later time, use use override: true
	public show(override: boolean = false, seconds: number = 4): Promise<any> {
		if (!this.hasRun || override) {
			this.hasRun = true;
			this.isShown = true;
			this.startTimer();
			if (this.setLoad) {
				return this.setLoad();
			} else {
				setTimeout(() => {
					this.stopTimer();
					this.isShown = false;
				}, seconds * 1000);
			}
		}

		return of().toPromise();
	}

	// call this to hide the splash timer. if you pass in a number for seconds, the timer will compare that number to the counted
	// time and either immediately hide the splash, or wait for the specified number of seconds before hiding the splash
	// ending the timer too quickly looks jarring, and 1 second seems like the lowest to appear smooth, but feel free to use what you want
	public hide(seconds?: number): Promise<any> {
		if (this.isShown) {
			if (seconds) {
				if (this.time < seconds) {
					setTimeout(() => {
						this.isShown = false;
					}, seconds * 1000);
				} else {
					this.isShown = false;
				}
			} else {
				this.isShown = false;
			}
		}

		return of().toPromise();
	}

	startTimer() {
		this.time = 0;
		this.timer = setInterval(() => {
			this.time++;
		}, 1000);
	}

	stopTimer() {
		clearInterval(this.timer);
	}
}
